export default "__VITE_ASSET__eQ30BAYp__"